import React, { useContext, useState } from 'react'
import { Context } from '../../../Store'
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from './ErrorMessage'

export const Gender = () => {
  const [state, dispatch] = useContext(Context)
  const [gender, setGender] = useState(state?.gender)
  const { t } = useTranslation()

  const genderValues = [
    {
      value: 'M',
      label: t('booking.userInfo.gender.male'),
    },
    {
      value: 'F',
      label: t('booking.userInfo.gender.female'),
    },
    {
      value: 'notSpecified',
      label: t('booking.userInfo.gender.notSpecified'),
    },
  ]

  const onChangeGender = (event) => {
    dispatch({ type: 'SET_GENDER', payload: event.target.value })
    setGender(event.target.value)
  }

  return (
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.userInfo.gender.title')}</Typography>
      <FormControl fullWidth variant="outlined">
        <InputLabel name="gender">{t('booking.userInfo.gender.placeholder')}</InputLabel>
          <Select
            name="gender"
            label={t('booking.userInfo.gender.placeholder')}
            value={gender}
            onChange={onChangeGender}
            error={state?.error?.gender}
          >
            {genderValues.map((value) => (
              <MenuItem key={value.value} value={value.value}>
                {value.label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
      {state?.error?.gender && <ErrorMessage error={state?.error?.gender} />}
    </Grid>
  )
}